import { Card, Text, TextProps } from '@chakra-ui/react'

export type StatCardPropTypes = {
  title: string
  value: string | number
  titleProps?: TextProps
  valueProps?: TextProps
}

export const StatCard = ({
  title,
  value,
  titleProps,
  valueProps,
}: StatCardPropTypes) => {
  return (
    <Card
      display={'flex'}
      p={2}
      justifyContent='center'
      alignItems={'center'}
      color='black'
      border='1px solid'
      borderColor='gray3'
      shadow={'none'}
    >
      <Text fontWeight='normal' fontSize={'sm'} color={'black'} {...titleProps}>
        {title}
      </Text>
      <Text fontWeight={'semibold'} {...valueProps}>
        {value}
      </Text>
    </Card>
  )
}
